module.exports = __webpack_public_path__ + "img/header.32c9d950.png";